app.service('accountEntityInvoices', function (account, accountConfig, companyName, vies, regon, validate, loading, modal, addressIntegrityValidator, broker) {

	let $self;
	let config;

	function init() {
		setElements();
		setEvents();

		config = accountConfig.getData();
	}

	function setElements() {
		$self = $('#additional-invoice-entity');
	}

	function setEvents() {

		$self
			.on('click', '.js-add-invoice-entity', function () {
				$('#invoice-data-0').empty();
				loadAdditionalEntityInvoiceEditForm();
			})
			.on('click', '.js-entity-invoice-cancel', function () {
				cancelEntityInvoiceEdit($(this).data('id'));
			})
			.on('click', '.js-edit-invoice-entity', function () {
				loadAdditionalEntityInvoiceEditForm($(this).data('id'));
			})
			.on('click', '.js-remove-invoice-entity', function () {
				removeAdditionalEntityInvoice($(this).data('id'));
			})
			.on('click', '.js-invoice-entity-set-default', function () {
				setDefaultAdditionalEntityInvoice($(this).data('id'));
			});
	}

	function setDefaultAdditionalEntityInvoice(invoiceEntityId) {

		let data = {};
		if (invoiceEntityId) {
			data.id = invoiceEntityId;
		}

		loading.start();

		$.ajax({
			url: '/customer-additional-invoice-entity-set-default.ltr',
			type: 'POST',
			cache: false,
			data
		})
			.then(() => loading.reload())
			.fail(() => modal.alert('Błąd ustawiania adresu domyślnego. Spróbuj ponownie.'))
			.always(() => loading.stop());
	}

	function loadAdditionalEntityInvoiceEditForm(invoiceEntityId = 0) {

		loading.start();

		let data = {};
		if (invoiceEntityId) {
			data.id = invoiceEntityId;
		}

		$.ajax({
			url: "/customer-additional-invoice-entity-edit.ltr",
			data
		}).then(html => {
			generateEntityInvoiceForm(html, invoiceEntityId);
		}).always(() => loading.stop());
	}

	function removeAdditionalEntityInvoice(invoiceEntityId = 0) {

		modal.generate({
			header: 'Czy na pewno chcesz usunąć dane podmiotu?',
			id: 'delete-address',
			buttons: [
				{
					text: 'Tak',
					cssClass: 'button-remove-address',
					click: function () {
						modal.close();
						makeRemoveAdditionalEntityInvoiceRequest(invoiceEntityId);
					}
				},
				{
					text: 'Anuluj',
					cssClass: 'button-cancel',
					click: function () {
						modal.close();
					}
				}
			]
		});
	}

	function makeRemoveAdditionalEntityInvoiceRequest(invoiceEntityId) {
		loading.start();
		let data = {};
		if (invoiceEntityId) {
			data.id = invoiceEntityId;
		}

		$.ajax({
			method: 'POST',
			url: "/customer-additional-invoice-entity-remove.ltr",
			data
		}).then(() => {
			loading.reload();
		}).always(() => loading.stop());
	}

	function generateEntityInvoiceForm(html, invoiceEntityId) {

		let employeeAddressRequired, taxIdType, role;

		let $div = $(`#entity-invoice-data-${invoiceEntityId}`);
		$div.html(html);
		let $form = $div.find('form');
		let $countryUe = $('#country-ue-' + invoiceEntityId);
		let $countryId = $('#country-id-' + invoiceEntityId);
		let $country = $('#country-code-' + invoiceEntityId);
		let $vatUe = $('#vat-ue-' + invoiceEntityId);
		let $nip = $('#nip-' + invoiceEntityId);
		let $companyName = $('#company-name-' + invoiceEntityId + '-textarea');
		let $invoiceAddress = $div.find('.invoice-address-box').find('input:not(#invoice-flat-number), textarea');
		let $taxIdTypeBoxes = $div.find('.tax-id-type-box');
		let $idNumber = $('#number-id-' + invoiceEntityId);
		let $internalId = $('#internal-id-' + invoiceEntityId);
		let $street = $('#street-' + invoiceEntityId);
		let $city = $('#city-name-' + invoiceEntityId);
		let $zipCode = $('#zipCode-' + invoiceEntityId);
		let $roleSelector = $("#role-" + invoiceEntityId)
		let $taxIdentifierSelector = $('#tax-identifier-selector-' + invoiceEntityId);
		let $employeeName = $('#additional-invoice-employee-name-' + invoiceEntityId);
		let $employeeAddressDetailsToggle = $('#employee-address-details-toggle-' + invoiceEntityId);

		taxIdType = $taxIdTypeBoxes.filter('.active').data('type') || "NIP";
		role = $roleSelector.data('js') || "RECIPIENT";
		employeeAddressRequired = $employeeAddressDetailsToggle.is(':checked') || false;

		$roleSelector.on('change', function handleRoleChange() {
			role = $(this).val();

			if (role === 'EMPLOYEE') {
				taxIdType = 'EMPTY_ID';
				$taxIdentifierSelector.val(taxIdType).trigger('change');
			}

			const isTaxPayerRoleSelected = role === 'JST_RECIPIENT' || role === 'VAT_GROUP_MEMBER_RECIPIENT';

			if (isTaxPayerRoleSelected) {
				const taxIdTypesAllowedForTaxPayerRoles = ['NIP', 'INTERNAL_ID'];

				if (!taxIdTypesAllowedForTaxPayerRoles.includes(taxIdType)) {
					taxIdType = 'NIP';
					$taxIdentifierSelector.val(taxIdType).trigger('change');
				}
			}

			setTaxIdTypeBox();
		});

		$employeeAddressDetailsToggle.on('click', function handleEmployeeAddressDetailsToggle() {
			employeeAddressRequired = $(this).is(':checked');
			renderForm();
		});

		validate.task('entityInvoice', {
			$form,
			send: function () {

				loading.start();

				if ($country.val() !== 'PL') {
					saveEntityInvoiceEditForm($form, invoiceEntityId);
					return;
				}

				if (role !== 'EMPLOYEE' || (role === 'EMPLOYEE' && employeeAddressRequired)) {
					addressIntegrityValidator.validate({
						data: {
							additionalEntityInvoiceCityName: $city.val(),
							additionalEntityInvoiceZipCode: $zipCode.val(),
							additionalEntityInvoiceStreet: $street.val(),
							isAdditionalEntityInvoice: true
						},
						onSuccess: () => saveEntityInvoiceEditForm($form, invoiceEntityId)
					});
				} else {
					saveEntityInvoiceEditForm($form);
				}
			}
		});

		$('.select3-input', $div).select3();

		$country.on('change', function () {
			if ($zipCode.val().length) {
				$form.validate().element($zipCode);
			}

			if ($country.val() === 'PL') {
				autocompleteDelivery('zipCode-' + invoiceEntityId, 'city-name-' + invoiceEntityId, 'street-' + invoiceEntityId);
				$zipCode.mask2("99-999");
			} else {
				unautocompleteDelivery('zipCode-' + invoiceEntityId, 'city-name-' + invoiceEntityId, 'street-' + invoiceEntityId);
				$zipCode.unmask2("99-999");
			}

			setZipCode($country.val());

			if (hasChangedPolishCountryCode($country)) {
				$(`#zipCode-${invoiceEntityId}, #city-name-${invoiceEntityId}, #street-${invoiceEntityId}, #house-number-${invoiceEntityId}, #flat-number-${invoiceEntityId}`).val(''); // czyścimy dane adresowe
			}

			$(this).data('prev-value', $(this).val());
		});

		if ($country.val() === 'PL') {
			autocompleteDelivery('zipCode-' + invoiceEntityId, 'city-name-' + invoiceEntityId, 'street-' + invoiceEntityId);
			$zipCode.mask2("99-999");
		}

		companyName.init('company-name-' + invoiceEntityId);

		$(`#number-id-${invoiceEntityId}-div`).on('input', function() {
			$idNumber.val($(this).text());
			$form.validate().element($idNumber);
		});

		regon.init({
			$country: $country,
			$box: $('#entity-invoice-data-' + invoiceEntityId + ' .regon-box'),
			$nip: $nip,
			$companyName: $('#company-name-' + invoiceEntityId + '-textarea-div'),
			$city: $city,
			$street: $street,
			$houseNumber: $('#house-number-' + invoiceEntityId),
			$flatNumber: $('#flat-number-' + invoiceEntityId),
			$zipCode: $zipCode
		});

		vies.init({
			$box: $('#entity-invoice-data-' + invoiceEntityId + ' .vies-box'),
			$button: $('#entity-invoice-data-' + invoiceEntityId + ' .js-vies-button'),
			$vatNumber: $vatUe,
			$country: $countryUe,
			$taxIdSelector: $self.find('#tax-identifier-selector-' + invoiceEntityId),
			nipEuValidate: config.nipEuValidate,
			validatedVatUeNumbers: config.validatedVatUeNumbers,
			onVatUeValidationUpdated: triggerVatUeValidation
		});

		broker.on('VIES_VERIFICATION_FINISHED', function (event, result) {
			if (result.success) {
				updateValidatedVatUeNumbersConfig(result.countryCode, result.vatUeNumber);
				triggerVatUeValidation();
			}
		});

		function updateValidatedVatUeNumbersConfig(countryCode, vatUeNumber) {
			if (!config.validatedVatUeNumbers.some(entry => entry[countryCode] && entry[countryCode].includes(vatUeNumber))) {
				config.validatedVatUeNumbers.push({[countryCode]: [vatUeNumber]});
			}
		}

		$countryId.on('change', function () {
			$form.validate().element($countryId);
		});

		$self.on('change', '#tax-identifier-selector-' + invoiceEntityId, function handleTaxIdentifierChange() {
			taxIdType = $(this).val();

			$countryId.val('').trigger('change');
			$countryUe.val('').trigger('change');

			setTaxIdTypeBox();
		});

		function hasChangedPolishCountryCode($countryCode) {
			const previousValue = $countryCode.data('prev-value');
			const currentValue = $countryCode.val();

			if (previousValue === 'PL' && currentValue !== 'PL') {
				return true;
			}

			return previousValue !== 'PL' && currentValue === 'PL';
		}

		function setZipCode(countryCode) {
			const isPolishCountryCode = countryCode === 'PL';
			const maxLength = isPolishCountryCode ? 6 : 8;
			const type = isPolishCountryCode ? 'tel' : 'text';

			$zipCode.prop({
				'maxlength': maxLength,
				'type': type
			});
		}

		function triggerVatUeValidation() {
			$form.validate().element($countryUe);
			$form.validate().element($vatUe);
		}

		function setTaxIdTypeBox() {

			if (taxIdType === "") return;

			$taxIdTypeBoxes
				.removeClass('active')
				.filter((i, el) => el.dataset.type === taxIdType)
				.addClass('active');

			renderForm();
		}

		function renderForm() {

			$taxIdentifierSelector.closest('.row-select').toggleClass('row-select-disabled', role === 'EMPLOYEE');
			$form.toggleClass('employee-role-selected', role === 'EMPLOYEE');
			$form.find('.invoice-address-box').toggleClass('is-hidden', role === 'EMPLOYEE' && !employeeAddressRequired);

			if (taxIdType === "VAT_UE") {
				$countryId.attr('disabled', 'disabled');
				$countryUe.removeAttr('disabled');
			}

			if (taxIdType === "NUMBER_ID") {
				$countryUe.attr('disabled', 'disabled');
				$countryId.removeAttr('disabled');
			}

			updateAvailableTaxIdTypes();
			updateValidation();
		}

		function updateAvailableTaxIdTypes() {

			const isTaxPayerRoleSelected = role === 'JST_RECIPIENT' || role === 'VAT_GROUP_MEMBER_RECIPIENT';

			const $taxIdTypeOptions = $taxIdentifierSelector.parent().find('.select3-option');

			if (isTaxPayerRoleSelected) {
				$taxIdTypeOptions.addClass('is-hidden')
					.filter('[data-value="NIP"], [data-value="INTERNAL_ID"]')
					.removeClass('is-hidden');
			} else {
				$taxIdTypeOptions.removeClass('is-hidden');
			}
		}

		function updateValidation() {

			ignoreAllCompanyFields();
			enableCompanyFieldsValidation();

			$invoiceAddress.ignore(role === 'EMPLOYEE' && !employeeAddressRequired);
		}

		function ignoreAllCompanyFields() {
			$idNumber.ignore(true);
			$vatUe.ignore(true);
			$nip.ignore(true);
			$countryUe.ignore(true);
			$countryId.ignore(true);
			$internalId.ignore(true);
			$employeeName.ignore(true);
		}

		function enableCompanyFieldsValidation() {

			const employeeRole = role === 'EMPLOYEE';

			let fieldsToValidate = {
				'NIP': () => {
					$nip.ignore(false);
					$companyName.ignore(false);
				},
				'VAT_UE': () => {
					$vatUe.ignore(false);
					$companyName.ignore(false);
					$countryUe.ignore(false);
				},
				'NUMBER_ID': () => {
					$idNumber.ignore(false);
					$companyName.ignore(false);
					$countryId.ignore(false);
				},
				'EMPTY_ID': () => {
					$companyName.ignore(employeeRole);
					$employeeName.ignore(!employeeRole);
				},
				'INTERNAL_ID': () => {
					$internalId.ignore(false);
					$companyName.ignore(false);
				}
			}

			return fieldsToValidate[taxIdType]();
		}
	}

	function saveEntityInvoiceEditForm($form, invoiceEntityId) {

		$form.ajaxSubmit({
			success: function (html) {
				loading.stop();
				if ($(html).filter('.success').length) {
					loading.reload();
				} else {
					generateEntityInvoiceForm(html, invoiceEntityId);
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd zapisu danych do faktury. Spróbuj ponownie później');
			}
		});
	}

	function cancelEntityInvoiceEdit(invoiceEntityId = 0) {
		let $div = $('#entity-invoice-data-' + invoiceEntityId);
		$div.empty();
	}

	return {
		init
	};
});